import React from "react";
import checked from "./../../../Images/checked.png";

const ButterflyHaircutWhyChoose = () => {
  return (
    <div className="faceWhyContainer">
      <h5>Why Choose SCENT Salon for Your Butterfly Hair Cut?</h5>
      <ul>
        <li>
          <span>
            <img src={checked} alt="" />
            Expert Stylists{" "}
          </span>
          <p>
            At SCENT Salon, our team of expert stylists is trained to create
            stunning Butterfly Hair Cuts that suit your unique style and
            preferences. We take the time to understand your hair type, face
            shape, and personal style to ensure you leave our salon feeling
            fabulous.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Trendy Atmosphere{" "}
          </span>
          <p>
            Our salon is designed to provide a relaxing and trendy atmosphere
            where you can enjoy your hair transformation. From the moment you
            walk in, you'll feel the positive energy and professionalism of our
            team, making your experience enjoyable.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Personalized Consultations{" "}
          </span>
          <p>
            {" "}
            We believe in personalized consultations to help you achieve your
            desired look. Our stylists will work with you to understand your
            vision and recommend the best options for your Butterfly Hair Cut,
            ensuring you feel confident in your choice.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Quality Products{" "}
          </span>
          <p>
            {" "}
            At SCENT Salon, we use only high-quality hair care products to
            ensure the health and longevity of your hairstyle. Our commitment to
            using the best products ensures that your hair looks and feels its
            best.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Client Satisfaction{" "}
          </span>
          <p>
            {" "}
            Client satisfaction is our top priority. We take pride in our
            ability to listen to our clients' needs and deliver exceptional
            results. Our goal is to make sure you leave the salon feeling happy
            and confident with your new Butterfly Hair Cut.
          </p>
          <p>
            The Butterfly Hair Cut is a versatile and trendy choice for women in
            Bangalore, suitable for both long and short hair. With its soft
            layers and flattering design, this haircut can elevate your style
            and enhance your natural beauty. At SCENT Salon, we are dedicated to
            providing you with the best experience and results, ensuring you
            leave our salon feeling fabulous. Whether you're ready to embrace
            this exciting trend or want to explore other hairstyles, our expert
            stylists are here to help you achieve the perfect look. Book your
            appointment today and experience the magic of the Butterfly Hair Cut
            at SCENT Salon!
          </p>
        </li>
      </ul>
    </div>
  );
};

export default ButterflyHaircutWhyChoose;
